import React from "react";
import { useAuth } from "../../context/AuthContext";
import CalendarPage from "./CalendarPage";
import MeetPage from "./MeetPage";

/** Admin uses Meet (list + notes); clients keep the week calendar. */
export default function CalendarRoute() {
  const { user } = useAuth();
  if (user?.role === "admin") return <MeetPage />;
  return <CalendarPage />;
}
